export const SETUP_BULLHORN_USER_REQUEST =
  'gustav/login/SETUP_BULLHORN_USER_REQUEST';
export const SETUP_BULLHORN_USER_SUCCESS =
  'gustav/login/SETUP_BULLHORN_USER_SUCCESS';
export const SETUP_BULLHORN_USER_ERROR =
  'gustav/login/SETUP_BULLHORN_USER_ERROR';

export const SETUP_GOOGLE_USER_REQUEST =
  'gustav/login/SETUP_GOOGLE_USER_REQUEST';
export const SETUP_GOOGLE_USER_SUCCESS =
  'gustav/login/SETUP_GOOGLE_USER_SUCCESS';
export const SETUP_GOOGLE_USER_ERROR = 'gustav/login/SETUP_GOOGLE_USER_ERROR';

export const SETUP_AZURE_USER_REQUEST = 'gustav/login/SETUP_AZURE_USER_REQUEST';
export const SETUP_AZURE_USER_SUCCESS = 'gustav/login/SETUP_AZURE_USER_SUCCESS';
export const SETUP_AZURE_USER_ERROR = 'gustav/login/SETUP_AZURE_USER_ERROR';

export const SIMPLE_LOGIN_ERROR = 'gustav/login/SIMPLE_LOGIN_ERROR';

export const SIGN_IN_REQUEST = 'gustav/login/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'gustav/login/SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'gustav/login/SIGN_IN_ERROR';

export const GET_SESSION_REQUEST = 'gustav/login/GET_SESSION_REQUEST';
export const GET_SESSION_SUCCESS = 'gustav/login/GET_SESSION_SUCCESS';
export const GET_SESSION_ERROR = 'gustav/login/GET_SESSION_ERROR';

export const GET_SESSION_VIA_TOKEN_REQUEST =
  'gustav/login/GET_SESSION_VIA_TOKEN_REQUEST';
export const GET_SESSION_VIA_TOKEN_SUCCESS =
  'gustav/login/GET_SESSION_VIA_TOKEN_SUCCESS';
export const GET_SESSION_VIA_TOKEN_ERROR =
  'gustav/login/GET_SESSION_VIA_TOKEN_ERROR';

export const GET_TOKEN_DATA_REQUEST = 'gustav/login/GET_TOKEN_DATA_REQUEST';
export const GET_TOKEN_DATA_SUCCESS = 'gustav/login/GET_TOKEN_DATA_SUCCESS';
export const GET_TOKEN_DATA_ERROR = 'gustav/login/GET_TOKEN_DATA_ERROR';

export const CREATE_LOGIN_TOKEN_REQUEST = 'gustav/login_tokens/CREATE_REQUEST';
export const CREATE_LOGIN_TOKEN_SUCCESS = 'gustav/login_tokens/CREATE_SUCCESS';
export const CREATE_LOGIN_TOKEN_ERROR = 'gustav/login_tokens/CREATE_ERROR';

export const CHECK_IFRAME_BULLHORN_USER_REQUEST =
  'gustav/login/CHECK_IFRAME_BULLHORN_USER_REQUEST';
export const CHECK_IFRAME_BULLHORN_USER_SUCCESS =
  'gustav/login/CHECK_IFRAME_BULLHORN_USER_SUCCESS';
export const CHECK_IFRAME_BULLHORN_USER_ERROR =
  'gustav/login/CHECK_IFRAME_BULLHORN_USER_ERROR';
